/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryDetailsResponse } from './categoryDetailsResponse';

export interface ManagementCategoryResponse { 
    id: string;
    value?: string;
    type?: ManagementCategoryResponse.TypeEnum;
    details?: Array<CategoryDetailsResponse>;
}
export namespace ManagementCategoryResponse {
    export type TypeEnum = 'CLIPPING';
    export const TypeEnum = {
        CLIPPING: 'CLIPPING' as TypeEnum
    };
}